function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10.5961 10.725C12.5848 8.73622 12.5848 5.51181 10.5961 3.52306C8.60731 1.5343 5.3829 1.5343 3.39415 3.52306C1.4054 5.51181 1.4054 8.73622 3.39415 10.725C5.3829 12.7137 8.60731 12.7137 10.5961 10.725ZM11.7964 2.32274C14.2452 4.77155 14.4325 8.62545 12.3584 11.2892C12.3714 11.3007 12.3841 11.3127 12.3965 11.3251L15.9975 14.9261C16.329 15.2575 16.329 15.7949 15.9975 16.1264C15.666 16.4579 15.1286 16.4579 14.7972 16.1264L11.1962 12.5254C11.1838 12.513 11.1718 12.5003 11.1603 12.4873C8.49654 14.5614 4.64264 14.3741 2.19383 11.9253C-0.45784 9.27362 -0.45784 4.97441 2.19383 2.32274C4.8455 -0.328933 9.14471 -0.328933 11.7964 2.32274Z",
  fill: "#4979C0"
});

var SvgLook = function SvgLook(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLook, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/look.34734257.svg";
export { ForwardRef as ReactComponent };